export default {
  title: 'Notificări despre rezervări',
  label: 'Unde să trimitem notificările despre rezervări?',
  placeholder: 'de ex. rezervari@restaurantuldvs.ro',
  helper:
    'Orice adresă de e-mail este potrivită — nu are nevoie de acces la panou. O puteți modifica sau puteți adăuga altele mai târziu în Rezervări → Setări → Notificări și confirmare.',
  errors: {
    required: 'Adăugați o adresă de e-mail pentru a primi notificările despre rezervări.',
    invalid: 'Introduceți o adresă de e-mail validă, de exemplu nume@restaurant.ro.',
  },
};
